import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getChecklistAfterAvailableColumns } from './api';
import { getChecklistAfterIndicatorListAllNotDeleted } from 'pages/PageChecklistAfterIndicatorList/api';
import { getChecklistAfterGroupListAllNotDeleted } from 'pages/PageChecklistAfterGroupList/api';
import { getChecklistAfterSeasonListAllNotDeleted } from 'pages/PageChecklistAfterSeasonList/api';

export const path = '/checklist/after/list';

const PageChecklistAfterList: React.FC = (props) => {
  const ChecklistAfterList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getChecklistAfterAvailableColumns,
      indicators: getChecklistAfterIndicatorListAllNotDeleted,
      groups: getChecklistAfterGroupListAllNotDeleted,
      seasons: getChecklistAfterSeasonListAllNotDeleted,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ChecklistAfterList {...props} />;
};

export default PageChecklistAfterList;
